import React from "react";
import { useTranslation } from "react-i18next";
import { NoRecordEmptyState } from "../../icons/EmptyStates";

interface GridEmptyStateProps {
  onAddRecord: () => void;
}

/**
 * Empty state shown when the grid has no records.
 * Displays an illustration, message, and a CTA button to add the first record.
 */
const GridEmptyState: React.FC<GridEmptyStateProps> = ({ onAddRecord }) => {
  const { t } = useTranslation();

  return (
    <div className="grid justify-items-center mt-20">
      <NoRecordEmptyState />
      <div className="space-y-2 text-center w-full">
        <div className="text-xl font-semibold tracking-tight">{t("No records")}</div>
        <div className="text-pretty text-gray-500">
          {t("No records yet! Add your first record to get started.")}
        </div>
        <button
          type="button"
          onClick={onAddRecord}
          className="rounded-sm bg-blue-600 px-4 py-2 text-xs font-semibold text-white shadow-xs hover:bg-blue-500 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-blue-600"
        >
          {t("New record")}
        </button>
      </div>
    </div>
  );
};

export default React.memo(GridEmptyState);
